import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
import { Meetings, Userspaces } from "@busy-human/opt-library";
import { useRouter } from "vue-router";
import { DataInstance } from "@busy-human/gearbox";
import CloseButton from "../buttons/close.vue";
import DetailsHeader from "./meeting-details-header.vue";

import TextField from "@/components/text-area.vue"

import CheckInPopup from "./check-in-popup.vue"
import CancelMeetingPopup from "./cancel-meeting.vue"
import RequestReschedulePopup from "./request-reschedule.vue"
import ReportProblemPopup from "./report-a-problem.vue"
import RunningLatePopup from "./running-late.vue"

import moment, { Moment } from 'moment';
import { useUserspace } from "@/store/userspace";

type Props = {
    selectedMeeting: DataInstance<Meetings.Model> | null
}
type Emits = {
    (e: "closePopup"): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'meeting-details',
  props: {
    selectedMeeting: null
  },
  emits: ["closePopup"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "closePopup"): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    selectedMeeting: DataInstance<Meetings.Model> | null
}




const router = useRouter();

//Display Popup Variables
const showCheckIn = ref(false)
const showCancel = ref(false)
const showPause = ref(false)
const showReport = ref(false)
const showRunningLate = ref(false)

const meetingMoment = ref<Moment>()

const meetingDuration = ref(0)

const meetingLink = ref<string>("")

const personalMessage = ref("")
const contactInfo = ref("")

const user = ref()
const otherUser = ref()
const collectorId = ref<string>("")
const payerId = ref<string>("")

const isPayingUser = ref<boolean>(false)
const meetingConfirmable = ref<boolean>(false)
const meetingReschedulable = ref<boolean>(false)
const meetingNotFinished = ref<boolean>(false)

const manage = ref<boolean>(false)
const reconfirmPayment = ref<boolean>(false)
const rescheduleRequested = ref<boolean>(false)
const rescheduleMessage = ref<string>('')

watch(() => props.selectedMeeting, async meeting => {
    if(meeting) {
        // console.log("MEETING", meeting)
        if(meeting.payer){
            payerId.value = meeting.payer
        }
        if(meeting.collector){
            collectorId.value = meeting.collector
        }
        let meetingStart = new Date(meeting.startTime)
        let meetingEnd = new Date(meeting.endTime)
        meetingDuration.value = (meetingEnd.valueOf() - meetingStart.valueOf()) / 60000

        meetingMoment.value = moment(meetingStart)

        meetingConfirmable.value = Meetings.canMeetingBeConfirmed(meeting)
        meetingNotFinished.value = !meetingConfirmable.value || meeting.status === Meetings.MeetingStatus.meetingStarted
        
        const currentUser = useUserspace().user;
        user.value = currentUser

        meetingReschedulable.value = Meetings.canMeetingBeRescheduled(meeting) && (meeting.status !== Meetings.MeetingStatus.rescheduleRequested || currentUser.$id === meeting.payer)
        if(currentUser.$id == meeting.collector){
            meetingLink.value = meeting.collectorLink || '404'

            try{
                otherUser.value = (await Userspaces.Collection.fetchDoc(meeting.payer)).data()
            }catch(e) {
                console.error("Other User Does not exist")
            }
        }else if(currentUser.$id == meeting.payer){
            meetingLink.value = meeting.payerLink || '404'

            isPayingUser.value = true;
            if(meeting.paymentStatus === 'failed'){
                reconfirmPayment.value = true
            }

            if(meeting.status === Meetings.MeetingStatus.rescheduleRequested){
                rescheduleRequested.value = true
                rescheduleMessage.value = meeting?.rescheduleNote || ''
            }

            try{
                otherUser.value = (await Userspaces.Collection.fetchDoc(meeting.collector)).data()
            }catch(e) {
                console.error("Other User Does not exist")
            }
        }

        //Meeting.from is the person who created the meeting. Currently the way the data is setup this means they are the "receiver"
        if((meeting.from === "payer" && isPayingUser.value) || (meeting.from === "collector" && !isPayingUser.value)){
            personalMessage.value = meeting.sendersNote
            contactInfo.value = meeting.sendersContactInfo

        }else{
            personalMessage.value = meeting.receiversNote
            
            contactInfo.value = meeting.receiversContactInfo
        }
    }
}, {immediate: true})

const closePopup = () => emit('closePopup');

const confirmMeeting = () => {
    router.push(`/check-in/${meetingLink.value}`);
}

const moveToRetryPage = () => {
    if(isPayingUser.value){
        router.push(`/retry-payment/${meetingLink.value}`);
    }
}

const moveToReschedule = () =>{
    if(!props.selectedMeeting) return;
    if(isPayingUser.value)
        router.push({name: 'meeting-reschedule', params: {meetingId: props.selectedMeeting.$id}})
    else{
        showPause.value = true
    }
}

const __returned__ = { props, emit, router, showCheckIn, showCancel, showPause, showReport, showRunningLate, meetingMoment, meetingDuration, meetingLink, personalMessage, contactInfo, user, otherUser, collectorId, payerId, isPayingUser, meetingConfirmable, meetingReschedulable, meetingNotFinished, manage, reconfirmPayment, rescheduleRequested, rescheduleMessage, closePopup, confirmMeeting, moveToRetryPage, moveToReschedule, onMounted, ref, watch, Meetings, Userspaces, useRouter, DataInstance, CloseButton, DetailsHeader, TextField, CheckInPopup, CancelMeetingPopup, RequestReschedulePopup, ReportProblemPopup, RunningLatePopup, moment, Moment, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})